import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyChanges: {
        id: 'endorsement.farm.view.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    PolicyChangeEfectiveDate: {
        id: 'endorsement.farm.views.payment.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.farm.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.farm.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    RenewalEffectiveDateMsgDesc: {
        id: 'endorsement.farm.view.Please confirm the policy change are for Renewal policy',
        defaultMessage: 'Please confirm the policy change are for Renewal policy'
    },
    RenewalEffectiveDateMsg: {
        id: 'endorsement.farm.view.Review Effective Date Changes',
        defaultMessage: 'Review Effective Date Changes'
    },
    mailingAddress: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Mailing Address',
        defaultMessage: 'Mailing Address'
    },
    mailingAddress: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Named Insured or Additional Named Insured(s)',
        defaultMessage: 'Named Insured or Additional Named Insured(s)'
    },
    PolicyChange: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Policy change',
        defaultMessage: 'Policy change'
    },
});
